/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectAzureBackupApplicationsRequest {
  /**
  * The service principal ID of the Eon backup application registration  created in the Eon tenant. This service principal is used by Eon  to perform backup operations across tenants. 
  */
  'eonBackupServicePrincipalId': string;
  /**
  * The application (client) ID of the backup application registration  created in the customer\'s Azure tenant. This application enables  Eon to access customer resources for backup operations. 
  */
  'customerBackupApplicationId': string;
  /**
  * The service principal ID associated with the customer backup  application registration. This service principal is granted  necessary permissions in the customer tenant for backup operations. 
  */
  'customerBackupServicePrincipalId': string;
  /**
  * The Azure tenant ID of the customer where the backup application  registration will be created. This identifies the customer\'s  Azure AD tenant. 
  */
  'customerTenantId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "eonBackupServicePrincipalId",
      "baseName": "eonBackupServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "customerBackupApplicationId",
      "baseName": "customerBackupApplicationId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "customerBackupServicePrincipalId",
      "baseName": "customerBackupServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "customerTenantId",
      "baseName": "customerTenantId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return ConnectAzureBackupApplicationsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

